<template>
    <div>
        <Boyo-Dialog :dialogInfo="dialogInfoData"
                    @dialogEvent="dialogEventData">
            <div style="display: flex; flex-direction: row; align-items: flex-start;">
              <!-- 左侧竖向步骤条 -->
              <div style="width: 220px; min-width: 220px; margin-right: 24px;">
                <el-steps direction="vertical" :active="activeValue" class="custom-steps-vertical">
                  <el-step v-for="(itemf, index) of activeList"
                          :key="index" :title="itemf.processNodeName" :description="itemf.approvalTime" :status="itemf.stepStatus || 'process'"></el-step>
                </el-steps>
              </div>
              <!-- 右侧内容 -->
              <div style="flex: 1; overflow-x: auto;">
                <Boyo-Formtwo :formInfo="formInfo2"
                        :refObj.sync="formInfo2.ref"
                        :listTypeInfo='listTypeInfo'
                        @handlePictureCardPreview="handlePictureCardPreview">
                </Boyo-Formtwo>
                <el-table :data="tableData" v-if="formInfo2.data.invoiceFlag == 1 || formInfo2.data.invoiceFlag == 2 || formInfo2.data.invoiceFlag == 3"
                        border
                        :summary-method="getSummaries"
                        show-summary
                        max-height="300px"
                        style="width: 100%;margin-top:2px;margin-bottom:3px"
                        :header-cell-style="{background:'rgb(189,215,252)',color:'#3C3C3C',padding:'4px 0'}"
                        :cell-style="{padding:'2px'}">
                  <el-table-column
                    type="index" fixed="left"
                    width="50">
                  </el-table-column>
                <el-table-column prop="invoiceNo"
                                align="center"
                                label="发票代码" width="100px">
                  <template slot-scope="scope">
                    <el-input size="small" :disabled="true"
                              v-model="scope.row.invoiceNo"></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="invoiceCode"
                                align="center"
                                label="发票号码" width="120px">
                  <template slot-scope="scope">
                    <el-input size="small" :disabled="true"
                              v-model="scope.row.invoiceCode"></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="invoiceDate"
                                align="center"
                                label="开票日期" width="140px">
                  <template slot-scope="scope">
                    <el-date-picker style="width:130px" :disabled="true"
                      v-model="scope.row.invoiceDate" value-format="yyyy-MM-dd"
                      type="date"
                      placeholder="选择日期">
                    </el-date-picker>
                  </template>
                </el-table-column>
                <el-table-column prop="invoicePrice"
                                align="center"
                                :label="'开票金额/'+amountUnit" width="95px">
                  <template slot-scope="scope">
                    <span>{{scope.row.invoicePrice?formatAmount(Number(scope.row.invoicePrice)):''}}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="invoiceImage"
                                align="center"
                                label="发票文件" width="130">
                    <template slot-scope="scope">
                        <span v-if="!scope.row.invoiceImage">暂无</span>
                        <span style="cursor:pointer" v-if="scope.row.invoiceImage" @click="previewAvatar({url:scope.row.invoiceImage})">查看</span>
                    </template>
                </el-table-column>
                <el-table-column prop="invoiceNote"
                                align="center"
                                label="备注">
                  <template slot-scope="scope">
                    <el-input size="small" :disabled="true"
                              v-model="scope.row.invoiceNote"></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="procureFlag" v-if="formInfo2.data.id"
                                align="center" width="60"
                                label="采购发票审批">
                  <template slot-scope="scope">
                    <p>{{scope.row.procureFlag?'已审':'未审'}}</p>
                  </template>
                </el-table-column>
                <el-table-column prop="financeFlag" v-if="formInfo2.data.id"
                                align="center" width="60"
                                label="财务发票审批">
                  <template slot-scope="scope">
                    <p>{{scope.row.financeFlag?'已审':'未审'}}</p>
                  </template>
                </el-table-column>
              </el-table>
                
                <!-- 审核表单 -->
                <div v-if="showAuditDataFields" style="margin-top: 20px; border-top: 1px solid #ebeef5; padding-top: 20px;">
                   <!-- 添加快捷短语区域 -->
        <div class="quick-phrase-area">
          <div class="quick-phrase-label">常用快捷短语:</div>
          <div class="quick-phrase-buttons">
            <el-button 
                v-for="(phrase, index) in quickPhrases" 
                :key="index"
                size="mini"
                @click="insertQuickPhrase(phrase)"
                class="phrase-btn">
                {{ phrase }}
            </el-button>
          </div>
        </div>
                  <Boyo-Formtwo :formInfo="formInfoAuditData"
                             :refObj.sync="formInfoAuditData.ref"
                             :listTypeInfo="listTypeInfo">
                  </Boyo-Formtwo>
                </div>
              </div>
            </div>
        </Boyo-Dialog>
        <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="pingImgUrl+dialogImageUrl" alt="">
        </el-dialog>
        <el-dialog :visible.sync="dialogVisible2" class="imgDialog">
            <img width="100%" :src="dialogImageUrl2" alt="">
        </el-dialog>
    </div>
</template>

<script>
import BoyoFilter from '@/components/BoyoFilter'
import BoyoContent from '@/components/BoyoContent'
import BoyoButton from '@/components/BoyoButton'
import BoyoTable from '@/components/BoyoTable'
import BoyoDialog from '@/components/BoyoDialog'
import BoyoForm from '@/components/BoyoForm'
import BoyoFormtwo from '@/components/BoyoFormtwo'
import config from '@/api/config'
export default {
  name: 'PaymentAdvDetailDialog',
  components: {
    BoyoFilter,
    BoyoContent,
    BoyoButton,
    BoyoTable,
    BoyoDialog,
    BoyoForm,BoyoFormtwo
  },
  props: {},
  data () {
    return {
      activeValue:null,
      activeList:[],
      dataId:'',
      search: {},
      tableData:[],
      detailDate:{},
      billId:'',
      add2:0,
      dialogVisible:false,
      dialogImageUrl:'',
      dialogImageUrl2: '',
      dialogVisible2: false,
      pingImgUrl: config.pingImgUrl,
      amountUnit:localStorage.amountUnit,
      auditParm:{},
      advanceRatio:'',
      createdBy: null, // 保存传入的制单人
      createdTime: null, // 保存传入的制单时间
      showAuditDataFields: false, // 是否显示审核表单
      quickPhrases: [
            '同意',
            '不同意',
            '需要补充相关附件',
            '预付款单'
        ],
        showPhraseManager: false,
        newPhrase: '',
      formInfoAuditData: {
        ref: null,
        labelWidth: '100px',
        data: {
          id:'',
          factoryAreaId:'',
          factoryAreaCode:'',
          factoryAreaName:'',
          processId:'',
          remark:'',
          status:'',
        },
        list: [
          { type: 'select流程名称：', label: '流程名称：', value: 'processId', list: 'processId', style: 'width:80%',disabled:true},
          { type: 'selectRadio', label: '审核：', value: 'status', style: 'width:95%', className: 'form_item_one',list:'statusFlag2',unclearable:true},
          { type: 'text', label: '备注：', value: 'remark', style: 'width:80%'},
        ],
        rules: {
          status:[{ required: true, trigger: 'change',message: '请选择' }]
        }
      },
      // 下拉框相关信息
      listTypeInfo: {
        billTypeCode:[],
        submitType:[{value:0,label:'直接通过'},{value:1,label:'多级流程'}],
        auditStatus:[{value:1,label:'已审核'},{value:0,label:'未审核'}],
        auditStatusTwo:[{value:'1',label:'已审核'},{value:'0',label:'未审核'}],
        payMentFlag:[{value:1,label:'已确认'},{value:0,label:'未确认'}],
        partnerId:[],
        partnerIdList:[],
        paymentMethod:[],
        orderBillNo:[],
        freeItem1:[{value:'已到达',label:'已到达'},{value:'否',label:'否'}],
        purPaymentCondit:[],
        financeFlag:[{value:0,label:'未审核'},{value:1,label:'已审核'}],
        procureFlag:[{value:0,label:'未审核'},{value:1,label:'已审核'}],
        invoiceFlag:[{value:0,label:'无发票'},{value:1,label:'未到票'},{value:2,label:'部分到票'},{value:3,label:'全部到票'},{value:4,label:'发票多收'}],
        contractCategory:[{ value: 0, label: '不限制' }, { value: 1, label: '集装箱合同' }, { value: 2, label: '临时合同' }, { value: 3, label: '车运合同' }, { value: 4, label: '船运合同' }, { value: 5, label: '办事处直采合同' }, { value: 6, label: '办事处外调合同' }, { value: 7, label: '办事处长协合同' }],
        contractId:[],
        businessType:[{value:0,label:'付款单'},{value:1,label:'预付款'}],
        settleType:[{value:'0',label:'合同'},{value:'1',label:'临时合同'},{value:'2',label:'无合同'}],
        bankId:[],
        invoiceStatus: [{ value: 0, label: '正常' }, { value: 1, label: '异常' }],
        positiveInvoice: [{ value: 0, label: '是' }, { value: 1, label: '否' }],
        factoryAreaId:[],
        statusFlag2:[{value:1,label:'同意'},{value:2,label:'不同意'}],
        processId:[],
      },
      // 表格相关
      tableInfo: {
        selection: false, // 是否显示表格单选框,
        xuhao: true,//序号显影
        selectReset: null, // 重置单选框选中
        mode: null, // 表格模板one和two两种
        data: [], // 数据
        total: 0, // 总条数
        pager: true, // 是否显示分页
        multipleSelection: [], // 表格单选框数据
        fieldList: [
          { value: "billNo",  label: "付款编号",  show: true, dropdown: true,sortable:true,fixed:'left', width: 110},
          { value: "businessType", label: "类型", show: true, dropdown: true,list:'businessType'},
          { value: "billDate",  label: "申请付款日期",  show: true, dropdown: true,sortable:true, width: 105},
          { value: 'orderBillNo',  label: '结算单号', show: true, dropdown: true, width: 105 },
          { value: 'partnerCode', label: '供应商编号', show: true, dropdown: true },
          { value: 'partnerName', label: '供应商', show: true, dropdown: true },
          { value: 'billRemark', label: '备注', show: true, dropdown: true },
          { value: "button", label: "操作", type: "slot", show: true, dropdown: true, width: 190,fixed:'right',align:'left' },
        ],
        btList: []
      },
      formInfo2: {
        ref: null,
        labelWidth: "112px",
        inline: true,
        data: {
          id:'',
          orderBillId:'',
          billDate:'',
          invoiceFlag: '',
          partnerId:'',
          partnerCode:'',
          partnerName:'',
          billTypeCode:'',
          billNo: '',
          bankName: '',
          bankAccount: '',
          bankAccountName: '',
          paymentMethod: '',
          billRemark: '',
          fileAddress: '',
          contractId: '',
          billImage:'',
          purMoney: '',
          advanceRatio:'',
          factoryAreaId:'',
          materialWeight:'',
        },
        list: [
          {type: "dateDay",label: "申请付款日：",value: "billDate", style: 'width:80%', className: 'form_item_two',disabled:true},
          {type: "text",label: "所属单位：",value: "factoryAreaId",remote:true, style: 'width:80%', className: 'form_item_two',disabled:true},
          { type: 'text', label: '合同/订单：', value: 'contractId',remote:true, style: 'width:80%', className: 'form_item_two', required: true,disabled:true},
          { type: 'text', label: '物料重量：', value: 'materialWeight', style: 'width:80%', className: 'form_item_two', disabled: true },
          { type: 'text', label: '供应商：', value: 'partnerName', style: 'width:92.5%', className: 'form_item_one', disabled: true },
          { type: 'text', label: '开户行：', value: 'bankName', style: 'width:80%', className: 'form_item_two',disabled:true },
          { type: 'text', label: '银行卡号：', value: 'bankAccount', style: 'width:80%', className: 'form_item_two',disabled:true },
          { type: 'text', label: '卡户姓名：', value: 'bankAccountName', style: 'width:80%', className: 'form_item_two',disabled:true},
          { type: 'select付款方式：', label: '付款方式：', value: 'paymentMethod',remote:true, style: 'width:80%', className: 'form_item_two',list:'paymentMethod', required: true ,disabled:true},
          {type: "text",label: "预付比例%：",value: "advanceRatio", style: 'width:80%', className: 'form_item_two',disabled:true,shows:true,show:true},
          { type: 'float', label: '付款金额：', value: 'purMoney', style: 'width:80%', className: 'form_item_two' ,disabled:false,disabled:true},
          {type: "text",label: "备注：",value: "billRemark", style: 'width:80%', className: 'form_item_two',disabled:true},
          { type: 'uploads', label: '付款图片：', value: 'billImage', style: 'width:80%', className: 'form_item_two',disabled:true},
          { type: 'uploadThree', label: '附件：', value: 'fileAddress', style: 'width:95%;margin-top: -90px;', className: 'form_item_two',fileListHt:[] ,disabled:true},

          // {type: "dateDay",label: "申请日期 ：",value: "billDate", style: 'width:80%', className: 'form_item_two',disabled:true},
          // { type: 'text', label: '合同编号：', value: 'contractId',remote:true, style: 'width:80%', className: 'form_item_two',disabled:true },
          // { type: 'text', label: '供应商：', value: 'partnerName', style: 'width:92%', className: 'form_item_one',disabled:true },
          // {type: "select单据类型：",label: "单据类型：",value: "billTypeCode",remote:true, style: 'width:80%', className: 'form_item_two',list:'billTypeCode',disabled:true},
          // { type: 'select发票状态：', label: '发票状态：', value: 'invoiceFlag',remote:true, style: 'width:80%', className: 'form_item_two',list:'invoiceFlag',disabled:true},
          // { type: 'text', label: '开户行：', value: 'bankName', style: 'width:80%', className: 'form_item_two',disabled:true},
          // { type: 'text', label: '银行卡号：', value: 'bankAccount', style: 'width:80%', className: 'form_item_two',disabled:true},
          // { type: 'text', label: '卡户姓名：', value: 'bankAccountName', style: 'width:80%', className: 'form_item_two',disabled:true},
          // { type: 'select付款方式：', label: '付款方式：', value: 'paymentMethod',remote:true, style: 'width:80%', className: 'form_item_two',list:'paymentMethod',disabled:true},
          // { type: 'float', label: '付款金额：', value: 'purMoney', style: 'width:80%', className: 'form_item_two',disabled:true},
          // {type: "text",label: "备注：",value: "billRemark", style: 'width:80%', className: 'form_item_two',disabled:true},
          // { type: 'uploads', label: '付款图片：', value: 'billImage', style: 'width:80%', className: 'form_item_two',disabled:true },
          // { type: 'uploadThree', label: '附件：', value: 'fileAddress', style: 'width:95%;margin-top: -90px;', className: 'form_item_two',fileListHt:[] ,disabled:true},
        ],
        rules: {}
      },
        dialogInfoData: {
            visible: false, // 弹框是否显示
            width: '1200px', // 宽度
            title: {
                add: '预付款单数据明细', // 标题
            },
            type: 'add', // 显示哪个标题
            // 按钮列表
            btList: [
                { label: '审核', type: 'success', icon: '', event: 'save', loading: false, show:false},
                { label: '关闭', type: '', icon: '', event: 'close', loading: false }
            ]
        },
    }
  },
  created () {
  },
  mounted () {
    this.$api.system.getSysUserAreaPage({pageNum:1,pageSize:0,userId:JSON.parse(localStorage.personal).userId}).then(res => {
      if (res.code === 0) {
        for (let i in res.data.list) {
          this.listTypeInfo.factoryAreaId.push({value:res.data.list[i].factoryAreaId,label:res.data.list[i].factoryAreaName,code:res.data.list[i].factoryAreaCode })
        }
      }else{
         this.$message({ message: res.msg, type: 'error' })
      }
    })
    this.$api.Customer.getBasePartnerPage({pageNum: 1, pageSize: 0,status:0,auditStatus:1,partnerType:1}).then(res => {//供应商
        if(res.code == 0) {
            let list5 = res.data.list
            for( let i in list5 ) {
                this.listTypeInfo.partnerIdList.push({value: list5[i].partnerId, label: list5[i].partnerName,partnerName:list5[i].partnerName,partnerCode:list5[i].partnerCode,
                corporateRepresentative:list5[i].corporateRepresentative,partnerAreaName:list5[i].partnerAreaName,phone:list5[i].phone,address:list5[i].address,payeeId:list5[i].payeeId,payeeName:list5[i].payeeName,
                purPaymentCondit:list5[i].purPaymentCondit,purPaymentMode:list5[i].purPaymentMode,scrapIronFlag:list5[i].scrapIronFlag,departureId:list5[i].departureId,purQuantityMax:list5[i].purQuantityMax,
                openBank:list5[i].openBank,bankId:list5[i].bankId,bankName:list5[i].bankName})
            }
        }
    })
    this.$api.dictionary.getSysEnumPage({pageNum: 1, pageSize: 0}).then(res => {//付款方式
        if(res.code == 0) {
            let list1 = res.data.list
            for( let i in list1) {
              if (list1[i].enumCategoryCode == 'PaymentMethod') {//支付方式
                this.listTypeInfo.paymentMethod.push({value: list1[i].enumName, label: list1[i].enumValue})
              } else if (list1[i].enumCategoryCode == 'PurPaymentCondit'){//付款条件
                this.listTypeInfo.purPaymentCondit.push({value: list1[i].enumValue, label: list1[i].enumValue})
              }
            }
        }
    })
    this.$api.dictionary.getSysTableTypePage({pageNum: 1, pageSize: 999,codeSysTable:'pur_order',forbidStatus:0,auditFlag:1}).then(res => {//单据类型
        if(res.code == 0) {
            let list6 = res.data.list
            for( let i in list6 ) {
              this.listTypeInfo.billTypeCode.push({value: list6[i].billTypeCode, label: list6[i].billTypeName,id:list6[i].id})
            }
        }
    })
  },
  methods: {
    dialogShow(data, val, parm, id, maker, makerTime){
        this.billId = data
        this.dataId = id
        // 保存传入的制单人和时间
        this.createdBy = maker
        this.createdTime = makerTime
        if(parm && parm.id){
          this.auditParm = parm
          this.dialogInfoData.btList[0].show = true
          this.showAuditDataFields = true
          
          // 初始化审核表单数据
          this.$nextTick(() => {
            for (const key in this.formInfoAuditData.data) {
              this.formInfoAuditData.data[key] = ''
            }
            
            // 查找并设置流程名称
            const loadProcessEnum = () => {
              return new Promise((resolve) => {
                if (this.listTypeInfo.processId && this.listTypeInfo.processId.length > 0) {
                  resolve();
                } else {
                  this.$api.ThirdPartyInterface.getActProcessConfigPage({pageNum: 1, pageSize: 999,carTypeArray:[2,3], status:1}).then(res => {
                    if(res.code == 0) {
                      let list1 = res.data.list
                      for(let i in list1) {
                        this.listTypeInfo.processId.push({value: list1[i].processId, enumValue: list1[i].processCode, label: list1[i].name})
                      }
                      resolve();
                    } else {
                      this.$message({ message: '加载流程枚举失败: ' + res.msg, type: 'error' })
                      resolve();
                    }
                  }).catch(() => {
                    resolve();
                  });
                }
              });
            };
            
            // 加载流程枚举后再设置流程名称
            loadProcessEnum().then(() => {
              let processFound = false;
              for (let inde of this.listTypeInfo.processId) {
                if (parm.processId == inde.enumValue) {
                  this.formInfoAuditData.data.processId = inde.value
                  processFound = true;
                  break;
                }
              }
              
              // 如果没找到匹配的流程，记录日志并设置一个默认值
              if (!processFound) {
                console.warn('未找到匹配的流程ID:', parm.processId, '可用的流程枚举:', this.listTypeInfo.processId);
                // 直接使用processId作为备选
                this.formInfoAuditData.data.processId = parm.processId;
              }
              
              this.formInfoAuditData.data.status = 1
            });
          })
        }else{
          this.dialogInfoData.btList[0].show = false
          this.showAuditDataFields = false
        }
        this.getInfo(val)
    },
    formatAmount(cellValue) {
      if (typeof cellValue == 'number') {
        cellValue = Number(cellValue.toFixed(2))
        return cellValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }else{
          return cellValue
      }
    },
    // 搜索事件
    getInfo (val) {
      this.$api.system.getActProcessEntryPage({idProcessInstance:this.dataId,pageNum:1,pageSize:999}).then(res => {
          if (res.code == 0) {
              this.activeList = []
              this.activeValue = 0
              for (let i in res.data.list) {
                  if(res.data.list[i].status && i < res.data.list.length){
                      this.activeValue = Number(Number(i) + 1)
                  }
                  let statusText = '';
                  let stepStatus = 'process';
                  if (res.data.list[i].status == 1) {
                    statusText = '(审核通过)';
                    stepStatus = 'success';
                  } else if (res.data.list[i].status == 2) {
                    statusText = '(已拒绝)';
                    stepStatus = 'error';
                  } else {
                    statusText = '(未完成)';
                    stepStatus = 'process';
                  }
                  this.activeList.push({
                    processNodeName: (res.data.list[i].processNodeName ? res.data.list[i].processNodeName : '流程节点名称暂无') + statusText,
                    approvalTime: res.data.list[i].status
                      ? (res.data.list[i].actualApprover + ' ' + res.data.list[i].approvalTime)
                      : (res.data.list[i].approver ? ('审批人：' + res.data.list[i].approver) : ('审批角色：' + res.data.list[i].roleName)),
                    stepStatus
                  });
              }
              
              // 始终在最前面插入"制单人"节点
              // 优先使用传入的制单人和时间，如果没有则尝试使用val中的数据
              let maker = this.createdBy || (val && val.createBy ? val.createBy : '暂无');
              let makerTime = this.createdTime || (val && val.createTime ? val.createTime : '');
              let approvalTime = maker + (makerTime ? (' ' + makerTime) : '');
              this.activeList.unshift({ processNodeName: '制单人', approvalTime });
              this.activeValue = (this.activeValue || 0) + 1;
          }else{
              this.$message({ message: res.msg, type: "error" });
          }
      })
      this.$api.OrderPurchase.getFinPaymentPage({id:this.billId,pageNum:1,pageSize:0}).then(
        res => {
          if (res.code == 0) {
            if(res.data.list.length > 0){
                this.detailDate = res.data.list[0]
                for (let key in this.formInfo2.data) {
                  if(key != 'orderBillNoTwo'){
                    this.formInfo2.data[key] = ''
                  }
                }
                for (let key in this.detailDate) {
                  if (key in this.formInfo2.data) {
                    this.formInfo2.data[key] = this.detailDate[key];
                  }
                }
                
                // 获取预付比例数据
                if (this.detailDate.contractId) {
                  this.$api.OrderPurchase.getPurOrderPage({pageNum: 1, pageSize: 0,hrReviewFlag:1,closeFlag:0,prepaymentFlag:1,deliveryEndFlag:0}).then(res => {
                    if(res.code == 0) {
                      let list5 = res.data.list
                      for( let i in list5) {
                        if(list5[i].businessCode){
                          if(list5[i].businessCode == this.detailDate.contractId){
                            this.formInfo2.data.purMode = list5[i].purMode
                            this.formInfo2.data.prepaymentFlag = list5[i].prepaymentFlag
                            if(list5[i].prepaymentFlag){
                              this.formInfo2.data.advanceRatio = list5[i].advanceRatio
                            }
                          }
                        }else{
                          if(list5[i].contractId == this.detailDate.contractId){
                            this.formInfo2.data.purMode = list5[i].purMode
                            this.formInfo2.data.prepaymentFlag = list5[i].prepaymentFlag
                            if(list5[i].prepaymentFlag){
                              this.formInfo2.data.advanceRatio = list5[i].advanceRatio
                            }
                          }
                        }
                      }
                    }
                  })
                }
                if (this.formInfo2.list[this.formInfo2.list.length - 1]) {
                  this.formInfo2.list[this.formInfo2.list.length - 1].fileListHt = []
                  if (this.detailDate.fileAddress) {
                    this.formInfo2.list[this.formInfo2.list.length - 1].fileListHt = [{name: (this.detailDate.fileAddress.split('-').length > 2)?this.detailDate.fileAddress.split('-')[2]:this.detailDate.fileAddress.split('-')[1],url: this.detailDate.fileAddress}]
                  }
                }
                this.$api.OrderPurchase.getFinPaymentEntryPage({idFinPayment:this.detailDate.id,pageNum:1,pageSize:999}).then(res => {
                  if (res.code == 0) {
                    for (let h in res.data.list) {
                      res.data.list[h].addIndex = h
                      if(res.data.list[h].invoiceImage){
                        res.data.list[h].fileListHt = [{name: (res.data.list[h].invoiceImage.split('-').length > 2)?res.data.list[h].invoiceImage.split('-')[2]:res.data.list[h].invoiceImage.split('-')[1],url: res.data.list[h].invoiceImage}]
                      }
                    }
                    this.tableData = res.data.list
                  }else{
                    this.$message({ message: res.msg, type: "error" });
                  }
                })
                if(!val){
                  this.dialogInfoData.visible = true
                }
            } else {
                this.$message({ message: '对应数据查找为空', type: 'warning' })
            }
          }else{
            this.$message({ message: res.msg, type: "error" });
          }
        },
        err => {
          console.log(err)
          this.content.loading = false
        }
      )
    },
    dialogEventData(event){
        const dialogInfoData = this.dialogInfoData
        switch (event) {
            case 'save':
              this.formInfoAuditData.ref.validate(valid => {
                if (valid) {
                  let parma = {
                    id: this.auditParm.id,
                    processId: this.formInfoAuditData.data.processId,
                    status: this.formInfoAuditData.data.status,
                    remark: this.formInfoAuditData.data.remark
                  }
                  dialogInfoData.btList[0].loading = true
                  this.$api.system.approval(parma).then(res => {
                    dialogInfoData.btList[0].loading = false
                    if (res.code === 0) {
                      this.$message({ message: res.msg, type: 'success' })
                      dialogInfoData.visible = false
                      this.showAuditDataFields = false
                      this.$emit('approvalInfo')
                    } else {
                      this.$message({ message: res.msg, type: 'error' })
                    }
                  }).catch(() => {
                    dialogInfoData.btList[0].loading = false
                  })
                }
              })
              break
            case 'close':
                dialogInfoData.visible = false
                this.showAuditDataFields = false
                break
        }
    },
    // 表单内部事件
    formClick (event) {
      switch (event) {
      }
    },
    getSummaries (param) {
      //param 是固定的对象，里面包含 columns与 data参数的对象 {columns: Array[4], data: Array[5]},包含了表格的所有的列与数据信息
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '小计';
          return;
        }
        for(let i=0; i<100;i++){
          if(sums[i]==0){
            sums[i]=''
          }
        }
        const values = data.map(item => Number(item[column.property]));
        if (column.property === 'invoicePrice' || column.property === 'purQuantity') {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[index] = sums[index]?this.formatAmount(Number(sums[index].toFixed(3))):'';
        }
      });
      this.$emit('getSummaries', sums)
      return sums;
    },
    previewAvatar(file) { // 查看文件
      window.open(config.pingImgUrl + file.url)
    },
    handlePictureCardPreview (url, value) {
      if(url){
        this.dialogVisible2 = true
        this.dialogImageUrl2 = url
      }
    },
    insertQuickPhrase(phrase) {
        // 获取当前备注值
        const currentRemark = this.formInfoAuditData.data.remark || '';
        
        // 插入短语到备注中
        if (currentRemark) {
            this.formInfoAuditData.data.remark = currentRemark + ' ' + phrase;
        } else {
            this.formInfoAuditData.data.remark = phrase;
        }
    },
    addNewPhrase() {
        if (this.newPhrase.trim()) {
            this.quickPhrases.push(this.newPhrase.trim());
            this.newPhrase = '';
        }
    },
    removePhrase(index) {
        this.quickPhrases.splice(index, 1);
    },
  }
}
</script>
<style lang="stylus" scoped>
.quick-phrase-area {
  margin-bottom: 15px;
  padding: 10px;
  background-color: #f5f7fa;
  border-radius: 4px;
  border: 1px dashed #dcdfe6;
}

.quick-phrase-label {
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 8px;
  color: #606266;
}

.quick-phrase-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.phrase-btn {
  margin: 0;
  white-space: nowrap;
}

.phrase-manager-btn {
  margin: 0;
}

.phrase-manager {
  max-height: 400px;
  overflow-y: auto;
}

.phrase-item {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.phrase-input {
  flex: 1;
  margin-right: 10px;
}

.phrase-delete-btn {
  flex-shrink: 0;
}

.phrase-add {
  display: flex;
  margin-top: 15px;
}

.phrase-add-input {
  flex: 1;
  margin-right: 10px;
}

.phrase-add-btn {
  flex-shrink: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Custom/PaymentAdvDetailDialog.vue